import { Injectable } from "@angular/core";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from "@angular/common/http";
import { AppConstant } from "src/app/app.constant";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Institute } from "./institute.classes";
import { DataResult, DataSourceRequestState } from "@progress/kendo-data-query";
import { LoaderService } from "src/app/_metronic/partials/content/loader/loader.service";
import { Branch } from "../branch/branch.classes";
import { Attachment } from "src/app/_metronic/core/classes/core.class";
import { ToasterService, ToasterType } from "src/app/services/toaster/toaster.service";

@Injectable()
export class InstitutionService {
    apiUrl: string;
    kendoDataUrl: string;
    constructor(private httpClient: HttpClient,
        private appConstant: AppConstant, private toasterService: ToasterService) {
        this.apiUrl = this.appConstant.getUrl()
    }
    manageInstitute(Institute) {

        return this.httpClient.post(`${this.apiUrl}/manageInstitute`, Institute).pipe(
            map((response: any) => {
                return response;
            })
        )
    }

    async getInstituteById(InstituteId): Promise<any> {
        return (await this.httpClient.get<GridDataResult>(`${this.apiUrl}/getInstituteById/` + InstituteId).toPromise()).data;
    }

    updateDefaultBranch(BranchData: Branch) {
        return this.httpClient.post(`${this.apiUrl}/updateDefaultBranch`, BranchData).pipe(
            map((response: any) => {
                return response;
            })
        );
    }

    public getAllInstitute(state): Observable<DataResult> {
        return this.httpClient.get(`${this.apiUrl}/getAllInstitute/`, state).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }

    getAllInstitutesForExcelExport(state: DataSourceRequestState) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(`${this.apiUrl}/getAllInstitute/` + state).pipe(
                map(res => res))
                .subscribe(res => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
        });
    }
    deleteAttachments(attachments: Attachment[]) {
        return this.httpClient.post(`${this.apiUrl}/fileBulkDelete`, attachments).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    applyReferralCode(code) {
        return this.httpClient.post(`${this.apiUrl}/applyReferralCode`, { ReferralCode: code }).pipe(
            map((response: any) => {
                return response;
            })
        )
    }

    public downloadInstituteInvoice(Id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(`${this.apiUrl}/downloadInstituteInvoice/` + Id, { responseType: 'blob' }).pipe(
                map(res => res))
                .subscribe(res => {
                    resolve(res);
                }, (err) => {
                    if (err.status == 403) {
                        this.toasterService.showToaster(null, "No data found!", ToasterType.Error)
                    }
                    reject(err);
                });
        });
    }

    generateInstituteToken(BranchId) {
        return this.httpClient.post(`${this.apiUrl}/refresh-token/branch`, { BranchId: BranchId }).pipe(
            map((response: any) => {
                return response;
            })
        );
    }
}
